module.exports = __webpack_public_path__ + "static/media/dashboard-icon.331bd9c9.png";